﻿if (!customElements.get('stockx-hero-rotator')) {
  class StockxHeroRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.stockx-market-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.stockx-market-hero__dot'));
      this.prevButton = this.querySelector('.stockx-market-hero__control--prev');
      this.nextButton = this.querySelector('.stockx-market-hero__control--next');
      this.currentIndex = 0;
      this.timer = null;
      this.slideCount = Number(this.dataset.slideCount || this.slides.length || 0);
      this.normalizeDescriptions();
      this.bindAddToCartForms();

      if (this.slideCount <= 1) {
        return;
      }

      this.intervalMs = Number(this.dataset.interval || 6000);
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';

      this.prevButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      });

      this.goTo(0);
      this.startAutoplay();
    }

    goTo(index) {
      if (!this.slides.length) return;

      const nextIndex = (index + this.slides.length) % this.slides.length;
      this.currentIndex = nextIndex;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    startAutoplay() {
      if (!this.autoplay || this.slideCount <= 1) {
        return;
      }

      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.intervalMs);
    }

    stopAutoplay() {
      if (!this.timer) {
        return;
      }

      clearInterval(this.timer);
      this.timer = null;
    }

    bindAddToCartForms() {
      const forms = this.querySelectorAll('.stockx-market-hero__atc-form');
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const btn = form.querySelector('button[type="submit"]');
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          const formData = new FormData(form);
          const body = JSON.stringify({
            id: Number(formData.get('id')),
            quantity: 1,
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body,
          })
            .then((res) => {
              if (!res.ok) throw new Error('Could not add to cart');
              return res.json();
            })
            .then((item) => {
              this.showConfirmation(item.title || item.product_title);
            })
            .catch(() => {
              this.showConfirmation(null);
            })
            .finally(() => {
              btn.disabled = false;
              btn.textContent = originalText;
            });
        });
      });
    }

    showConfirmation(productTitle) {
      const existing = document.querySelector('.stockx-hero-atc-toast');
      if (existing) existing.remove();

      const toast = document.createElement('div');
      toast.className = 'stockx-hero-atc-toast';

      if (productTitle) {
        toast.innerHTML =
          '<span class="stockx-hero-atc-toast__icon">&#10003;</span>' +
          '<span class="stockx-hero-atc-toast__text">' +
            '<strong>' + productTitle + '</strong> has been added to your cart' +
          '</span>';
      } else {
        toast.innerHTML =
          '<span class="stockx-hero-atc-toast__icon" style="color:#c00">&#10007;</span>' +
          '<span class="stockx-hero-atc-toast__text">Something went wrong. Please try again.</span>';
      }

      document.body.appendChild(toast);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          toast.classList.add('is-visible');
        });
      });

      setTimeout(() => {
        toast.classList.remove('is-visible');
        toast.addEventListener('transitionend', () => toast.remove(), { once: true });
        setTimeout(() => toast.remove(), 500);
      }, 3000);
    }

    normalizeDescriptions() {
      if (!this.slides?.length) {
        return;
      }

      this.slides.forEach((slide) => {
        const description = slide.querySelector('.stockx-market-hero__copy');
        if (!description || description.dataset.normalized === 'true') {
          return;
        }

        const tables = Array.from(description.querySelectorAll('table'));
        tables.forEach((table) => {
          const rows = Array.from(table.querySelectorAll('tr'));
          const items = rows
            .map((row) => {
              const cells = Array.from(row.querySelectorAll('th, td'))
                .map((cell) => cell.textContent.replace(/\s+/g, ' ').trim())
                .filter(Boolean);

              if (!cells.length) {
                return null;
              }

              const label = cells[0].replace(/[:\s]+$/, '');
              const value = cells.slice(1).join(' ').trim();
              return { label, value };
            })
            .filter(Boolean);

          if (!items.length) {
            table.remove();
            return;
          }

          const list = document.createElement('ul');
          list.className = 'stockx-market-hero__facts';

          items.forEach((item) => {
            const listItem = document.createElement('li');
            listItem.className = 'stockx-market-hero__facts-item';

            if (item.value) {
              const label = document.createElement('strong');
              label.textContent = `${item.label}:`;
              listItem.append(label, document.createTextNode(` ${item.value}`));
            } else {
              listItem.textContent = item.label;
            }

            list.appendChild(listItem);
          });

          table.replaceWith(list);
        });

        description.dataset.normalized = 'true';
      });
    }
  }

  customElements.define('stockx-hero-rotator', StockxHeroRotator);
}

